import { useBoundStore } from '@/store/store';

import { queryClient } from './queryClient';

export async function applyOrganizationContext(context: {
  access: string;
  organizationId: string;
  destination: string;
}) {
  useBoundStore.setState({ organizationTransitioning: true });
  await queryClient.cancelQueries();
  useBoundStore.setState({
    jwt: context.access,
    currentOrganizationId: context.organizationId,
    chat: null,
    activeSubscription: null,
  });
  queryClient.clear();
  window.location.assign(context.destination);
}
